var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from '@reduxjs/toolkit';
var initialState = {
    loginActions: {
        hasReviewedInvites: false,
    },
};
export default createReducer(initialState, {
    'session/setIsPublicLink': function (state, action) {
        state.isPublicLink = action.payload;
    },
    'session/setIsMobile': function (state) {
        var isMobile = window.matchMedia('only screen and (max-width: 639px)').matches;
        return __assign(__assign({}, state), { isMobile: isMobile });
    },
    'session/invitesReviewed': function (state) {
        state.loginActions.hasReviewedInvites = true;
    },
});
